<template>
  <i18n path="app.link_tag_to_organismo_confirmation" tag="div" class="space-x-1">
    <template #tag>
      <el-tooltip>
        <div slot="content">{{ valores[0] }}</div>
        <!-- <div class="truncate font-semibold max-w-feedbacktag"> ETIQUETA LARGA LARGA TEST</div> -->
        <span class="truncate font-semibold max-w-feedbacktag"> {{ valores[0] }} <br/></span>
      </el-tooltip>
    </template>
    <template #organism>
      <el-tooltip>
        <div slot="content">{{ valores[1] }}</div>
        <span class="truncate font-semibold max-w-feedbackorganismo"> {{ valores[1] }} </span>
      </el-tooltip>
    </template>
  </i18n>
</template>

<script>
export default {
  name: 'feedback-content-tag-agency',
  props: {
    valores: {
      type: [Array],
      default: null
    },
  }
}
</script>
